pn-multiple-input {
  .multiple-input-generated-row,
  .multiple-input-row {
    display: flex;
    gap: 1rem;

    pn-marketweb-input {
      width: 100%;
    }
  }

  .multiple-input-slot {
    display: flex;
    gap: 1rem;
    flex-direction: column;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}
